export default defineNuxtRouteMiddleware(async (to) => {
    if (to.path === '/dashboard' || to.path.startsWith('/dashboard/')) {
        if (import.meta.server) return;

        const { user, refreshIdentity } = useSanctumAuth();

        if (!user.value) {
            try {
                await refreshIdentity();
            } catch {
                // Unauthenticated guest or expired session
            }
        }

        if (!user.value) {
            return navigateTo({
                path: '/auth/login',
                query: { redirectTo: to.fullPath },
            });
        }
    }
});

